function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function EmailIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M1 4L1.03381 6.2616C1.11877 7.29517 1.66925 8.24793 2.51367 8.76123L10.1914 14.0259C10.7407 14.4023 11.3701 14.5908 12 14.5908C12.6294 14.5908 13.2593 14.4023 13.8086 14.0259L21.4414 8.79053C22.3284 8.24951 22.8825 7.29291 22.9665 6.25763L23 4H1ZM20.3555 7.11182L12.6777 12.3765C12.2656 12.6587 11.7344 12.6587 11.3223 12.3765L3.59961 7.08252C3.22998 6.85693 3 6.44238 3 6H21C21 6.44238 20.77 6.85693 20.3555 7.11182Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M21 10.9103V17C21 17.5513 20.5513 18 20 18H4C3.44873 18 3 17.5513 3 17V10.9136L1.66553 9.99854C1.4256 9.85309 1.20703 9.67487 1 9.48267V17C1 18.6543 2.3457 20 4 20H20C21.6543 20 23 18.6543 23 17V9.46387C22.7623 9.68958 22.5067 9.89801 22.2227 10.0713L21 10.9103Z",
    fill: "currentColor"
  }));
}
export function EmailIconSmall(props) {
  return ___EmotionJSX(EmailIcon, _extends({
    size: "small"
  }, props));
}